module.exports = __webpack_public_path__ + "static/media/404.c0d51037.svg";